module.exports = __webpack_public_path__ + "static/media/current-status-playing.7d00cf38.jpg";